import type { UiLocale } from '../../shared/models';

export function AccessDeniedState({ locale, onHome }: { locale: UiLocale; onHome: () => void }) {
  return <section className="empty-state-card" role="status">
    <span className="eyebrow">Access</span>
    <h2>{locale === 'zh-CN' ? '当前页面已不可访问' : 'This page is no longer available to you'}</h2>
    <p>{locale === 'zh-CN'
      ? '你的当前餐厅空间权限可能刚刚发生变化。系统已经按最新权限刷新；如需继续使用此功能，请联系 Workspace Owner。'
      : 'Your Workspace access may have changed. The app has refreshed to the latest permissions; contact a Workspace Owner if you still need this feature.'}</p>
    <button className="primary-button compact" type="button" onClick={onHome}>{locale === 'zh-CN' ? '返回首页' : 'Back to home'}</button>
  </section>;
}
